module.exports = __webpack_public_path__ + "static/media/pin.7b3d9f30.png";